import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import * as moment from 'moment';
import translate from '../../../commonComponents/translate';
import RewardProp from '../propTypes/rewardProp';
import { useHost } from '../../../services/customHooks';

const RewardsGeneral = ({ createInputHint, createImage, reward, onChange, hostDomain }) => (
  <>
    {createInputHint(
      'reward',
      'textarea',
      false,
      'col-lg-2 col-4',
      'col-lg-5 col-8',
      reward?.description || '',
      onChange('general', 'description'),
    )}
    {createImage(
      'rewardImage',
      'docContainer',
      'col-lg-2 col-4 text-right',
      '',
      { cropWidth: 350, cropHeight: 350 },
      onChange('general', 'image'),
      reward?.image || { url: `${hostDomain}/image/placeholder/350/350` },
    )}
  </>
);
RewardsGeneral.propTypes = {
  createInputHint: PropTypes.func.isRequired,
  createImage: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  reward: PropTypes.shape(RewardProp.propType),
  hostDomain: PropTypes.string.isRequired,
};
RewardsGeneral.defaultProps = {
  reward: null,
};

const RewardsCoins = ({ t, createInputHint, reward, onChange }) => (
  <>
    <h4 className="col-2 text-right rewards-title">
      {t('access_session.detail.coins')}
    </h4>
    {createInputHint('coinsAmount', 'text', false, 'col-lg-2 col-4', 'col-lg-5 col-8', reward?.coins, onChange('coins', 'coins'))}
  </>
);
RewardsCoins.propTypes = {
  /** Translation function */
  t: PropTypes.func.isRequired,
  createInputHint: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  reward: PropTypes.shape(RewardProp.propType),
};
RewardsCoins.defaultProps = {
  reward: null,
};

const RewardsVoucher = ({ t, createImage, reward, onChange, isFinished, hostDomain }) => {
  const [colors, setColors] = useState({
    text: reward?.voucher?.textColor ? reward.voucher.textColor : '#FFFFFF',
    background: reward?.voucher?.backgroundColor ? reward.voucher.backgroundColor : '#000000',
  });
  const handleColor = field => event => {
    onChange('voucher', field)(event.target.value);
  };
  useEffect(() => {
    setColors({
      text: reward?.voucher?.textColor ? reward.voucher.textColor : '#000000',
      background: reward?.voucher?.backgroundColor ? reward.voucher.backgroundColor : '#FFFFFF',
    });
  }, [reward]);
  return (
    <>
      <h4 className="col-2 text-right rewards-title">{t('access_session.detail.voucher')}</h4>
      <div className="row">
        <div className="col-lg-6">
          <label
            htmlFor="voucher"
            className="radio radial-rewards"
          >
            <span className="radio__input">
              <input
                id="voucher"
                type="checkbox"
                value="voucher"
                checked={!!reward?.voucher?.enabled}
                onChange={ev => {
                  onChange('voucher', 'enabled')(ev.target.checked);
                }}
                disabled={isFinished}
              />
                <span className="radio__control" />
            </span>
            <span className="radio__label">{t('access_session.detail.convertCoins')}</span>
          </label>
          <div className="textColor-input row">
            <label style={{ alignSelf: 'center' }} className="col-4 text-right" htmlFor="textColor">
              {t('access_session.detail.textColor')}
            </label>
            <input
              type="text"
              value={colors.text}
              readOnly
              className="form-control m-input col-5 textColor-text"
            />
            <input
              type="color"
              id="textColor"
              name="textColor"
              value={colors.text}
              onChange={handleColor('textColor')}
              disabled={isFinished}
            />
          </div>
          <div className="backgroundColor-input row">
            <label
              style={{ alignSelf: 'center' }}
              className="col-4 text-right"
              htmlFor="backgroundColor"
            >
              {t('access_session.detail.backgroundColor')}
            </label>
            <input
              type="text"
              value={colors.background}
              readOnly
              className="form-control m-input col-5 backgroundColor-text"
            />
            <input
              type="color"
              id="backgroundColor"
              name="backgroundColor"
              value={colors.background}
              onChange={handleColor('backgroundColor')}
              disabled={isFinished}
            />
          </div>
          <div className="logo-input">
            {createImage(
              'logo',
              'docContainer',
              'col-lg-4 col-12 text-right',
              '',
              { cropWidth: 100, cropHeight: 50 },
              onChange('voucher', 'logo'),
              reward?.voucher?.logo || { url: `${hostDomain}/image/placeholder/100/50?fontSize=20` },
            )}
          </div>
        </div>
        <div className="col-lg-6">
          <h5 className="title-preview_voucher">
            {t('access_session.detail.previewVoucher')}
          </h5>
          <div className="voucher-preview">
            <div
              className="fileinput-new thumbnail voucher-container-preview"
              style={{ backgroundColor: colors.background }}
            >
              <div className="voucher-logo">
                <img
                  id="logoPreview"
                  className="voucher-logo-img"
                  src={reward?.voucher?.logo?.url
                    ? reward?.voucher?.logo.url
                    : `${hostDomain}/image/placeholder/100/50?fontSize=20`}
                  alt=""
                />
              </div>
              <div className="voucher-date" style={{ color: colors.text }}>
                <i className="fa fa-clock-o" />
                {moment().format('DD MMMM, YYYY')}
              </div>
              <div className="voucher-amount" style={{ color: colors.text }}>0.00€</div>
              <div className="voucher-code" style={{ color: colors.text }}>000-00000</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
RewardsVoucher.propTypes = {
  /** Translation function */
  t: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  createImage: PropTypes.func.isRequired,
  reward: PropTypes.shape(RewardProp.propType),
  isFinished: PropTypes.bool,
  hostDomain: PropTypes.string.isRequired,
};
RewardsVoucher.defaultProps = {
  reward: null,
  isFinished: false,
};

function RewardsCoupon({ t, createInput, createImage, reward, onChange, isFinished, hostDomain }) {
  return (
    <>
      <h4 className="col-2 text-right rewards-title">{t('access_session.detail.coupon')}</h4>
      <div className="row">
        <div className="">
          <label
            htmlFor="coupon"
            className="radio radial-rewards"
          >
            <span className="radio__input">
              <input
                id="coupon"
                type="checkbox"
                value="couponWin"
                checked={!!reward?.coupon?.enabled}
                onChange={ev => {
                  onChange('coupon', 'enabled')(ev.target.checked);
                }}
                disabled={isFinished}
              />
                <span className="radio__control" />
            </span>
            <span className="radio__label">{t('access_session.detail.couponWin')}</span>
          </label>
          <div className="couponName-input">
            {createInput(
              'couponName',
              'text',
              false,
              'col-4 text-right',
              'col-5',
              reward?.coupon?.name,
              onChange('coupon', 'name'),
            )}
          </div>
          <div className="image-input">
            {createImage(
              'couponImage',
              'docContainer',
              'col-4 text-right',
              '',
              { cropWidth: 330, cropHeight: 140 },
              onChange('coupon', 'image'),
              reward?.coupon?.image || { url: `${hostDomain}/image/placeholder/330/140` },
            )}
          </div>
        </div>
      </div>
    </>
  );
}
RewardsCoupon.propTypes = {
  /** Translation function */
  t: PropTypes.func.isRequired,
  createInput: PropTypes.func.isRequired,
  createImage: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  reward: PropTypes.shape(RewardProp.propType),
  isFinished: PropTypes.bool,
  hostDomain: PropTypes.string.isRequired,
};
RewardsCoupon.defaultProps = {
  reward: null,
  isFinished: false,
};

function RewardsCertificate({ t, createInput, createImage, reward, onChange, isFinished, hostDomain }) {
  // BRAVON-6613 — a session's certificate duration is the span of its Time
  // Period step, so the preview shows that rather than a sample.
  //
  // Those date inputs live in the non-React half of this hybrid form, so they
  // are read from the DOM and watched for changes — the datepicker publishes
  // jQuery events, which never surface as native DOM events. Guarded because
  // this component can be SERVER-rendered, where neither `document` nor `$`
  // exists; there the span is 0 and the client fills it in on hydration.
  const [sessionSpan, setSessionSpan] = useState(0);

  useEffect(() => {
    if (typeof document === 'undefined') {
      return undefined;
    }
    const format = 'DD MMM YYYY - HH:mm';
    const read = id => (document.getElementById(id) || {}).value;
    const compute = () => {
      const span =
        moment(read('endDate'), format).valueOf() -
        moment(read('startDate'), format).valueOf();
      setSessionSpan(Number.isFinite(span) && span > 0 ? span : 0);
    };
    compute();

    const selector = '#startDate, #endDate';
    const jq = typeof window !== 'undefined' ? window.$ : null;
    if (jq) {
      jq(selector).on('change dp.change changeDate', compute);
      return () => jq(selector).off('change dp.change changeDate', compute);
    }
    const nodes = ['startDate', 'endDate']
      .map(id => document.getElementById(id))
      .filter(Boolean);
    nodes.forEach(node => node.addEventListener('change', compute));
    return () =>
      nodes.forEach(node => node.removeEventListener('change', compute));
  }, []);

  const generateUrl = () => `/certificate/placeholder/preview?link=${
    reward?.certificate?.link ? encodeURIComponent(reward.certificate.link) : ''
  }&color=${
    reward?.certificate?.color ? encodeURIComponent(reward.certificate.color) : ''
  }&logo=${
    reward?.certificate?.logo?.url ? encodeURIComponent(reward.certificate.logo.url) : ''
  }&signature=${
    reward?.certificate?.signature?.thumb ? encodeURIComponent(reward.certificate.signature.thumb) : ''
  }&entityName=${
    reward?.certificate?.entityName ? encodeURIComponent(reward.certificate.entityName) : ''
  }&legalInfo=${
    reward?.certificate?.legalInfo ? encodeURIComponent(reward.certificate.legalInfo) : ''
  }&duration=${sessionSpan}`;
  const [iframeUrl, setIframeUrl] = useState(generateUrl());
  const handleColor = event => {
    onChange('certificate', 'color')(event.target.value);
  };

  useEffect(() => {
    setIframeUrl(generateUrl());
  }, [reward, sessionSpan]);
  return (
    <>
      <h4 className="col-2 text-right rewards-title">{t('access_session.detail.certificate')}</h4>
      <div className="row">
        <div className="col-lg-6">
          <label
            htmlFor="certificate"
            className="radio radial-rewards"
          >
            <span className="radio__input">
              <input
                id="certificate"
                type="checkbox"
                checked={!!reward?.certificate?.enabled}
                onChange={ev => {
                  onChange('certificate', 'enabled')(ev.target.checked);
                }}
                disabled={isFinished}
              />
                <span className="radio__control" />
            </span>
            <span className="radio__label">{t('access_session.detail.awardCertificate')}</span>
          </label>
          <div className="couponName-input">
            {createInput(
              'entityName',
              'text',
              false,
              'col-4 text-right',
              'col-7',
              reward?.certificate?.entityName || '',
              onChange('certificate', 'entityName'),
            )}
            {createInput(
              'legalInfo',
              'text',
              false,
              'col-4 text-right',
              'col-7',
              reward?.certificate?.legalInfo || '',
              onChange('certificate', 'legalInfo'),
            )}
          </div>
          <div className="image-input">
            {createImage(
              'logoCertificate',
              'docContainer',
              'col-4 text-right',
              '',
              { cropWidth: 250, cropHeight: 100 },
              onChange('certificate', 'logo'),
              reward?.certificate?.logo || { url: `${hostDomain}/image/placeholder/250/100?fontSize=44` },
            )}
          </div>
          {/* <div className="row"> */}
          {/*  /!* eslint-disable-next-line jsx-a11y/label-has-associated-control,jsx-a11y/label-has-for *!/ */}
          {/*  <label */}
          {/*    style={{ alignSelf: 'center' }} */}
          {/*    className="col-4 text-right" */}
          {/*  /> */}
          {/*  <div className="col-7 checkboxes-certificates "> */}
          {/*    <div className="printCertificate"> */}
          {/*      <label className="checkbox" htmlFor="printCertificate"> */}
          {/*        <input */}
          {/*          type="checkbox" */}
          {/*          id="printCertificate" */}
          {/*          name="printCertificate" */}
          {/*          value={!!reward?.certificate?.canPrint} */}
          {/*          onChange={onChange('certificate', 'canPrint')} */}
          {/*        /> */}
          {/*        <span className="default" /> */}
          {/*      </label> */}
          {/*      <span className="checkbox-label"> */}
          {/*        {t('access_session.detail.printCertificate')} */}
          {/*      </span> */}
          {/*    </div> */}
          {/*    <div className="buyCertificate"> */}
          {/*      <label className="checkbox" htmlFor="buyCertificate"> */}
          {/*        <input */}
          {/*          type="checkbox" */}
          {/*          id="buyCertificate" */}
          {/*          name="buyCertificate" */}
          {/*          value={!!reward?.certificate?.canPurchase} */}
          {/*          onChange={onChange('certificate', 'canPurchase')} */}
          {/*        /> */}
          {/*        <span className="default" /> */}
          {/*      </label> */}
          {/*      <div className="checkbox-label"> */}
          {/*        {t('access_session.detail.buyCertificate')} */}
          {/*      </div> */}
          {/*    </div> */}
          {/*  </div> */}
          {/* </div> */}
        </div>
        <div className="col-lg-6" style={{ position: 'relative' }}>
          {createInput(
            'link',
            'text',
            false,
            'col-4 text-right',
            'col-7',
            reward?.certificate?.link || '',
            onChange('certificate', 'link'),
          )}
          <div className="color-input row">
            <label
              style={{ alignSelf: 'center' }}
              className="col-4 text-right"
              htmlFor="color"
            >
              {t('access_session.detail.color')}
            </label>
            <input
              type="text"
              value={reward?.certificate?.color || ''}
              readOnly
              className="form-control m-input col-6 colorText-text"
            />
            <input
              type="color"
              id="color"
              name="color"
              onChange={handleColor}
              disabled={isFinished}
            />
          </div>
          <div className="image-input">
            {createImage(
              'signature',
              'docContainer',
              'col-4 text-right',
              '',
              { cropWidth: 250, cropHeight: 100 },
              onChange('certificate', 'signature'),
              reward?.certificate?.signature || { url: `${hostDomain}/image/placeholder/250/100?fontSize=44` },
            )}
          </div>
        </div>
        <div className="col-12">
          <div className="preview-certificate">
            <label className="col-2 text-right" htmlFor="color">
              {t('access_session.detail.preview')}
            </label>
            <div className="certificate-container" style={{ width: '100%' }}>
              <div className="certificate-preview-wrapper">
                <iframe
                  className="certificate-preview"
                  title="certificatePreview"
                  id="certificatePreview"
                  src={iframeUrl}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
RewardsCertificate.propTypes = {
  /** Translation function */
  t: PropTypes.func.isRequired,
  createInput: PropTypes.func.isRequired,
  createImage: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  reward: PropTypes.shape(RewardProp.propType),
  isFinished: PropTypes.bool,
  hostDomain: PropTypes.string.isRequired,
};
RewardsCertificate.defaultProps = {
  reward: null,
  isFinished: false,
};

function TabRewards({ t, reward, createInput, createImage, createInputHint, handleChange, isFinished }) {
  const hostDomain = useHost();
  const handleUpdate = (tab, field) => value => {
    switch (tab) {
      case 'general':
      case 'coins':
        handleChange('reward')({
          ...reward,
          [field]: value,
        });
        break;
      case 'voucher':
      case 'coupon':
      case 'certificate':
        handleChange('reward')({
          ...reward,
          [tab]: {
            ...reward?.[tab] || {},
            [field]: value,
          },
        });
        break;
      default:
        break;
    }
  };

  return (
    <div className="row">
      <div className="col-lg-2 col-md-6 col-xs-12">
        <div className="rewards-tabs">
          <ul className="nav nav-tabs rewards-nav" role="tablist">
            <li className="rewards-nav_item nav-item">
              <a
                className="rewards-nav_link nav-link btn btn-sm active show"
                data-toggle="tab"
                href="#"
                data-target="#m_tabs_1_1"
              >
                <span className="rewards-nav_link-text">{t('access_session.detail.general')}</span>
              </a>
            </li>
            <li className="rewards-nav_item nav-item">
              <a
                className="rewards-nav_link nav-link btn btn-sm"
                data-toggle="tab"
                href="#"
                data-target="#m_tabs_1_2"
              >
                <span className="rewards-nav_link-text">{t('access_session.detail.coins')}</span>
              </a>
            </li>
            <li className="rewards-nav_item nav-item">
              <a
                className="rewards-nav_link nav-link btn btn-sm"
                data-toggle="tab"
                href="#"
                data-target="#m_tabs_1_3"
              >
                <span className="rewards-nav_link-text">{t('access_session.detail.voucher')}</span>
              </a>
            </li>
            <li className="rewards-nav_item nav-item">
              <a
                className="rewards-nav_link nav-link btn btn-sm"
                data-toggle="tab"
                href="#"
                data-target="#m_tabs_1_4"
              >
                <span className="rewards-nav_link-text">{t('access_session.detail.coupon')}</span>
              </a>
            </li>
            <li className="rewards-nav_item nav-item">
              <a
                className="rewards-nav_link nav-link btn btn-sm"
                data-toggle="tab"
                href="#"
                data-target="#m_tabs_1_5"
              >
                <span className="rewards-nav_link-text">{t('access_session.detail.certificate')}</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="col-lg-10 col-md-6 col-xs-12">
        <div className="tab-content">
          <div className="tab-pane active rewards-tab" id="m_tabs_1_1" role="tabpanel">
            <RewardsGeneral
              createInputHint={createInputHint}
              onChange={handleUpdate}
              createImage={createImage}
              reward={reward}
              hostDomain={hostDomain}
            />
          </div>
          <div className="tab-pane rewards-tab" id="m_tabs_1_2" role="tabpanel">
            <RewardsCoins
              t={t}
              createInputHint={createInputHint}
              reward={reward}
              onChange={handleUpdate}
              hostDomain={hostDomain}
            />
          </div>
          <div className="tab-pane rewards-tab" id="m_tabs_1_3" role="tabpanel">
            <RewardsVoucher
              t={t}
              createImage={createImage}
              reward={reward}
              onChange={handleUpdate}
              isFinished={isFinished}
              hostDomain={hostDomain}
            />
          </div>
          <div className="tab-pane rewards-tab" id="m_tabs_1_4" role="tabpanel">
            <RewardsCoupon
              t={t}
              createInput={createInput}
              createImage={createImage}
              reward={reward}
              onChange={handleUpdate}
              isFinished={isFinished}
              hostDomain={hostDomain}
            />
          </div>
          <div className="tab-pane rewards-tab" id="m_tabs_1_5" role="tabpanel">
            <RewardsCertificate
              t={t}
              createInput={createInput}
              createImage={createImage}
              reward={reward}
              onChange={handleUpdate}
              isFinished={isFinished}
              hostDomain={hostDomain}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

TabRewards.propTypes = {
  /** Translation function */
  t: PropTypes.func.isRequired,
  reward: PropTypes.shape(RewardProp.propType),
  createInput: PropTypes.func.isRequired,
  createInputHint: PropTypes.func.isRequired,
  createImage: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  isFinished: PropTypes.bool,
};
TabRewards.defaultProps = {
  reward: null,
  isFinished: false,
};

export default translate(TabRewards);
